import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import {Observable} from 'rxjs';
import {UserService} from '@core/services';
import {environment} from '@env';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private userService: UserService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      this.userService.accessToken &&
      !request.headers.get('X-CSCAPI-KEY') &&
      !request.url.startsWith(environment.amazonBaseUrl) &&
      !request.url.startsWith(environment.amazonBaseUrlDev)
    ) {
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${this.userService.accessToken}`
        }
      });
    }
    return next.handle(request);
  }
}
